module.exports = __webpack_public_path__ + "static/media/illustration-rptstd-create-responsive.282032c4.svg";